import ImageWMS from 'ol/source/ImageWMS';
import { Image as ImageLayer } from 'ol/layer.js';
import { urlWMS, urlWFS, formatoImagen, versionWMS, capasTematicas, fechaHoy, urlLegend } from './configuracion.js';
//
// Capas temáticas
//
export const capitales = new ImageLayer({
  id: 'capitales',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:v_capitales',
    }
  })
});
export const ccppAsentamientosDispersos = new ImageLayer({
  id: 'ccppAsentamientosDispersos',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:ccpp_asentamientos_dispersos',
    }
  })
});
export const tiempoDesplazamientoCapitalCercano = new ImageLayer({
  id: 'tiempoDesplazamientoCapitalCercano',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:tiempo_deplazamiento_capital_cercano',
    }
  })
});
export const ccppCategorizacionRecategorizacion = new ImageLayer({
  id: 'ccppCategorizacionRecategorizacion',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:ccpp_cate_recate',
    }
  })
});
export const ccppReconocimientoLey = new ImageLayer({
  id: 'ccppReconocimientoLey',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:ccpp_reconocimiento_ley',
    }
  })
});
export const densidadViviendas = new ImageLayer({
  id: 'densidadViviendas',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:densidad_viviendas,geoportal:densidad_viviendas_7km,geoportal:densidad_viviendas_12km',
    }
  })
});
export const densidadServiciosFinancieros = new ImageLayer({
  id: 'densidadServiciosFinancieros',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:densidad_servicio_financiero,geoportal:densidad_servicio_financiero_2km,geoportal:densidad_servicio_financiero_10km,geoportal:densidad_servicio_financiero_30km',
        //'LAYERS': 'geoportal:densidad_servicio_financiero',
    }
  })
});
export const densidadComercio = new ImageLayer({
  id: 'densidadComercio',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:densidad_comercio,geoportal:densidad_comercio_1km,geoportal:densidad_comercio_10km,geoportal:densidad_comercio_30km',
        //'LAYERS': 'geoportal:densidad_comercio',
    }
  })
});
export const densidadMercado = new ImageLayer({
  id: 'densidadMercado',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:densidad_mercado,geoportal:densidad_mercado_1km,geoportal:densidad_mercado_10km,geoportal:densidad_mercado_30km',
        //'LAYERS': 'geoportal:densidad_mercado',
    }
  })
});
export const densidadInmobiliario = new ImageLayer({
  id: 'densidadInmobiliario',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:densidad_inmobiliario,geoportal:densidad_inmobiliario_2km,geoportal:densidad_inmobiliario_10km,geoportal:densidad_inmobiliario_30km',
        //'LAYERS': 'geoportal:densidad_inmobiliario',
    }
  })
});
export const densidadDelitos = new ImageLayer({
  id: 'densidadDelitos',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:densidad_delitos',
    }
  })
});
export const viasNacional = new ImageLayer({
  id: 'viasNacional',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:red_vial_nacional_2022',
    }
  })
});
export const viasDepartamental = new ImageLayer({
  id: 'viasDepartamental',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:red_vial_departamental_2022',
    }
  })
});
export const viasVecinal = new ImageLayer({
  id: 'viasVecinal',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:red_vial_vecinal_2022',
    }
  })
});
export const aerodromos = new ImageLayer({
  id: 'aerodromos',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:aerodromo_2022',
    }
  })
});
export const comunidadesNativas = new ImageLayer({
  id: 'comunidadesNativas',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: 'https://winlmprap09.midagri.gob.pe/winlmprap13/services/ogc/Catastro_Rural/MapServer/WMSServer?',
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': '4',
    }
  })
});
export const comunidadesCampesinas = new ImageLayer({
  id: 'comunidadesCampesinas',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: 'https://winlmprap09.midagri.gob.pe/winlmprap13/services/ogc/Catastro_Rural/MapServer/WMSServer?',
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': '5',
    }
  })
});
export const evaluacionRiesgos = new ImageLayer({
  id: 'evaluacionRiesgos',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:evaluacion_riesgos',
    }
  })
});
export const zonasRiesgosNoMitigable = new ImageLayer({
  id: 'zonasRiesgosNoMitigable',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:zonas_riesgos_no_mitigable',
    }
  })
});
export const inventarioInundaciones = new ImageLayer({
  id: 'inventarioInundaciones',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:inventario_inundaciones',
    }
  })
});
export const tramosCriticosInundaciones = new ImageLayer({
  id: 'tramosCriticosInundaciones',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:tramos_criticos_inundaciones',
    }
  })
});
export const puntosCriticosInundaciones = new ImageLayer({
  id: 'puntosCriticosInundaciones',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:puntos_criticos_inundaciones',
    }
  })
});
export const areasExposicionInundaciones = new ImageLayer({
  id: 'areasExposicionInundaciones',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:areas_exposicion_inundacion',
    }
  })
});
export const areasExposicionMovimientoMasa = new ImageLayer({
  id: 'areasExposicionMovimientoMasa',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:areas_exposicion_movimientos_masa',
    }
  })
});
export const zonasCriticasMovimientoMasa = new ImageLayer({
  id: 'zonasCriticasMovimientoMasa',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:zonas_criticas_movimientos_masa',
    }
  })
});
export const inventarioMovimientoMasa = new ImageLayer({
  id: 'inventarioMovimientoMasa',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:inventario_movimientos_masa',
    }
  })
});
export const serviciosEducativos = new ImageLayer({
  id: 'serviciosEducativos',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:servicios_educativos',
    }
  })
});
export const localesEducativos = new ImageLayer({
  id: 'localesEducativos',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:locales_educativos',
    }
  })
});
export const institucionesPrestadorasServiciosSalud = new ImageLayer({
  id: 'institucionesPrestadorasServiciosSalud',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:instituciones_prestadoras_servicios_salud',
    }
  })
});
export const limiteDepartamental = new ImageLayer({
  id: 'limiteDepartamental',
  visible: true,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:v_departamentos_2023',
    }
  })
});
export const limiteProvincial = new ImageLayer({
  id: 'limiteProvincial',
  visible: true,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:v_provincias_2023',
    }
  })
});
export const limiteDistrital = new ImageLayer({
  id: 'limiteDistrital',
  visible: true,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:v_distritos_2023',
    }
  })
});
export const flujoTrabajo25000 = new ImageLayer({
  id: 'flujoTrabajo25000',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_trb_25000',
    }
  })
});
export const flujoTrabajo10000a25000 = new ImageLayer({
  id: 'flujoTrabajo10000a25000',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_trb_10000_25000',
    }
  })
});
export const flujoTrabajo5000a10000 = new ImageLayer({
  id: 'flujoTrabajo5000a10000',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_trb_5000_10000',
    }
  })
});
export const flujoTrabajo1500a5000 = new ImageLayer({
  id: 'flujoTrabajo1500a5000',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_trb_1500_5000',
    }
  })
});
export const flujoTrabajo100a1500 = new ImageLayer({
  id: 'flujoTrabajo100a1500',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_trb_100_1500',
    }
  })
});
export const flujoEstudiantes13000 = new ImageLayer({
  id: 'flujoEstudiantes13000',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_est_13000',
    }
  })
});
export const flujoEstudiantes7000a13000 = new ImageLayer({
  id: 'flujoEstudiantes7000a13000',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_est_7000_13000',
    }
  })
});
export const flujoEstudiantes3500a7000 = new ImageLayer({
  id: 'flujoEstudiantes3500a7000',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_est_3500_7000',
    }
  })
});
export const flujoEstudiantes1000a3500 = new ImageLayer({
  id: 'flujoEstudiantes1000a3500',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_est_1000_3500',
    }
  })
});
export const flujoEstudiantes100a1000 = new ImageLayer({
  id: 'flujoEstudiantes100a1000',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:flujo_est_100_1000',
    }
  })
});
export const densidadCrecimientoPoblacional = new ImageLayer({
  id: 'densidadCrecimientoPoblacional',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:densidad_crecimiento_poblacional',
    }
  })
});
export const vabCallao = new ImageLayer({
  id: 'vabCallao',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:ccpp150_vab_callao',
    }
  })
});
export const vabLima = new ImageLayer({
  id: 'vabLima',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:ccpp150_vab_lima',
    }
  })
});
export const vabTotal = new ImageLayer({
  id: 'vabTotal',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:ccpp150_vab_total',
    }
  })
});
export const coberturaMovOper = new ImageLayer({
  id: 'coberturaMovOper',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:cobertura_movil_oper',
    }
  })
});
export const coberturaMovTipo = new ImageLayer({
  id: 'coberturaMovTipo',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:cobertura_movil_tipo',
    }
  })
});
export const densidadCrecimientoPobCcpp = new ImageLayer({
  id: 'densidadCrecimientoPobCcpp',
  visible: false,
  source: new ImageWMS({
    ratio: 1,
    url: urlWMS,
    crossOrigin: 'Anonymous',
    params: {
        'FORMAT': formatoImagen,
        'VERSION': versionWMS,
        'TRANSPARENT': true, 
        'STYLES': '',
        //'exceptions': exepcion,
        'LAYERS': 'geoportal:densidad_crecimiento_pob_ccpp',
    }
  })
});
// function activarBoton(id, estado){
//   const button = document.getElementById('btn'+ id);
//   if(estado) button.style.display = '';
//   else button.style.display = 'none';
// }

//
// ACTIVAR CAPAS Y MOSTRAR CUADRO DE LEYENDA
//

function activarBoton(id, estado) {
  const button = document.getElementById('btn' + id);
  if (estado) {
    button.style.display = '';
  } else {
    button.style.display = 'none';
  }

  // Identificadores de los checkboxes seleccionados
  const idsRelevantes = [
    'tiempoDesplazamientoCapitalCercano',
    'densidadViviendas',
    'densidadServiciosFinancieros',
    'densidadComercio',
    'densidadMercado',
    'densidadInmobiliario',
    'densidadDelitos',
    'densidadCrecimientoPoblacional',
    'densidadCrecimientoPobCcpp',
    'vabLima',
    'vabCallao',
    'vabTotal',
    'coberturaMovOper',
    'coberturaMovTipo',
    'flujoTrabajo25000',
    'flujoTrabajo10000a25000',
    'flujoTrabajo5000a10000',
    'flujoTrabajo1500a5000',
    'flujoTrabajo100a1500',
    'flujoEstudiantes13000',
    'flujoEstudiantes7000a13000',
    'flujoEstudiantes3500a7000',
    'flujoEstudiantes1000a3500',
    'flujoEstudiantes100a1000',
    'capitales',
    'ccppAsentamientosDispersos',
    'viasNacional',
    'viasDepartamental',
    'viasVecinal',
    'serviciosEducativos',
    'localesEducativos',
  ];

  // Diccionario para los enlaces y capas
  const capasPorId = {
    tiempoDesplazamientoCapitalCercano: 'tiempo_deplazamiento_capital_cercano',
    densidadViviendas: 'densidad_viviendas',
    densidadServiciosFinancieros: 'densidad_servicio_financiero',
    densidadComercio: 'densidad_comercio',
    densidadMercado: 'densidad_mercado',
    densidadInmobiliario: 'densidad_inmobiliario',
    densidadDelitos: 'densidad_delitos',
    densidadCrecimientoPoblacional: 'densidad_crecimiento_poblacional',
    densidadCrecimientoPobCcpp: 'densidad_crecimiento_pob_ccpp',
    vabLima: 'ccpp150_vab_lima',
    vabCallao: 'ccpp150_vab_callao',
    vabTotal: 'ccpp150_vab_total',
    coberturaMovOper: 'cobertura_movil_oper',
    coberturaMovTipo: 'cobertura_movil_tipo',
    flujoTrabajo25000: 'flujo_trb_25000',
    flujoTrabajo10000a25000: 'flujo_trb_10000_25000',
    flujoTrabajo5000a10000: 'flujo_trb_5000_10000',
    flujoTrabajo1500a5000: 'flujo_trb_1500_5000',
    flujoTrabajo100a1500: 'flujo_trb_100_1500',
    flujoEstudiantes13000: 'flujo_est_13000',
    flujoEstudiantes7000a13000: 'flujo_est_7000_13000',
    flujoEstudiantes3500a7000: 'flujo_est_3500_7000',
    flujoEstudiantes1000a3500: 'flujo_est_1000_3500',
    flujoEstudiantes100a1000: 'flujo_est_100_1000',
    capitales: 'v_capitales',
    ccppAsentamientosDispersos: 'ccpp_asentamientos_dispersos',
    viasNacional: 'red_vial_nacional_2022',
    viasDepartamental: 'red_vial_departamental_2022',
    viasVecinal: 'red_vial_vecinal_2022',
    serviciosEducativos: 'servicios_educativos',
    localesEducativos: 'locales_educativos',
  };

  // Diccionario para los enlaces
  const nombresPorId = {
    tiempoDesplazamientoCapitalCercano: 'Tiempo de desplazamiento a la capital más cercana',
    densidadViviendas: 'Densidad de viviendas',
    densidadServiciosFinancieros: 'Densidad de establecimientos financieros',
    densidadComercio: 'Densidad de comercios',
    densidadMercado: 'Densidad de mercados',
    densidadInmobiliario: 'Densidad de actividades inmobiliarias',
    densidadDelitos: 'Densidad de delitos',
    densidadCrecimientoPoblacional: 'Crecimiento poblacional a nivel de centros poblados',
    densidadCrecimientoPobCcpp: 'Centros poblados con tasa de crecimiento poblacional',
    vabLima: 'Valor Agregado Bruto (VAB) Lima',
    vabCallao: 'Valor Agregado Bruto (VAB) Callao',
    vabTotal: 'Valor Agregado Bruto (VAB) excepto Lima y Callao',
    coberturaMovOper: 'Servicio móvil por cantidad de operadoras por centro poblado',
    coberturaMovTipo: 'Servicio móvil por tipo de tecnología por centro poblado',
    flujoTrabajo25000: 'Flujo laboral (> 25 000)',
    flujoTrabajo10000a25000: 'Flujo laboral (10 000 - 25 000)',
    flujoTrabajo5000a10000: 'Flujo laboral (5 000 - 10 000)',
    flujoTrabajo1500a5000: 'Flujo laboral (1 500 - 5 000)',
    flujoTrabajo100a1500: 'Flujo laboral (100 - 1 500)',
    flujoEstudiantes13000: 'Flujo por estudios (> 13 000)',
    flujoEstudiantes7000a13000: 'Flujo por estudios (7 000 - 13 000)',
    flujoEstudiantes3500a7000: 'Flujo por estudios (3 500 - 7 000)',
    flujoEstudiantes1000a3500: 'Flujo por estudios (1 000 - 3 500)',
    flujoEstudiantes100a1000: 'Flujo por estudios (100 - 1 000)',
    capitales: 'Capitales',
    viasNacional: 'Vías Nacionales',
    viasDepartamental: 'Vías Departamentales',
    viasVecinal: 'Vías Vecinales',
    ccppAsentamientosDispersos: 'Centros poblados',
    serviciosEducativos: 'Servicios educativos',
    localesEducativos: 'Locales educativos',
  };

  // Diccionario para los textos adicionales debajo de las imágenes
  const textosAdicionales = {
    tiempoDesplazamientoCapitalCercano: '',
    densidadViviendas: 'Viviendas/Ha',
    densidadServiciosFinancieros: 'Establecimientos/Km<sup>2</sup>',
    densidadComercio: 'Comercios/Km<sup>2</sup>',
    densidadMercado: 'Mercados/Km<sup>2</sup>',
    densidadInmobiliario: 'Actividades/Km<sup>2</sup>',
    densidadDelitos: 'Delitos/Km<sup>2</sup>',
    densidadCrecimientoPoblacional: '',
    densidadCrecimientoPobCcpp: 'Tasa de crecimiento (%)',
    vabLima: 'Miles de soles',
    vabCallao: 'Miles de soles',
    vabTotal: 'Miles de soles',
    coberturaMovOper: 'Número de empresas operadoras',
    coberturaMovTipo: 'Tipo de tecnología',
    flujoTrabajo25000: '',
    flujoTrabajo10000a25000: '',
    flujoTrabajo5000a10000: '',
    flujoTrabajo1500a5000: '',
    flujoTrabajo100a1500: '',
    flujoEstudiantes13000: '',
    flujoEstudiantes7000a13000: '',
    flujoEstudiantes3500a7000: '',
    flujoEstudiantes1000a3500: '',
    flujoEstudiantes100a1000: '',
    capitales: '',
    ccppAsentamientosDispersos: 'Población (Censo 2017)',
    viasNacional: '',
    viasDepartamental: '',
    viasVecinal: '',
    serviciosEducativos: 'Nivel/Modalidad',
    localesEducativos: 'Área geográfica',
  };

  // Verifica si alguno de estos checkboxes está activo
  const checkboxes = Array.from(document.querySelectorAll('.form-check-input'));
  const encontrado = checkboxes.some(
    checkbox => checkbox.checked && idsRelevantes.includes(checkbox.id)
  );

  // Elementos HTML
  const legend = document.getElementById('legend');
  const leyendaLista = document.getElementById('leyenda-lista');

  // Mostrar u ocultar el botón según el resultado
  if (encontrado) {
    legend.style.display = 'block'; // Mostrar el botón

    // Actualizar la lista de enlaces
    leyendaLista.innerHTML = ''; // Limpiar la lista

    // Genera dinámicamente la lista, manteniendo el orden del arreglo enlacesPorCapa....
    checkboxes.forEach(checkbox => {
      if (checkbox.checked && capasPorId[checkbox.id]) {
        const capa = capasPorId[checkbox.id];
        const nombre = nombresPorId[checkbox.id];
        const textoAdicional = textosAdicionales[checkbox.id] || '';

        const li = document.createElement('li');
        li.innerHTML = `
          <a href="#" class="leyenda-enlace">
            <span class="icono">▼</span> ${nombre}
          </a>
          <div class="contenido-leyenda" style="display: block;">
            ${textoAdicional ? `<div style="padding-left: 20px;">${textoAdicional}</div>` : ''}
            <img style="padding-left: 16px;" src="${urlLegend}${capa}" alt="Leyenda">
          </div>
        `;

        // Agrega evento al enlace
        const enlace = li.querySelector('.leyenda-enlace');
        const contenidoLeyenda = li.querySelector('.contenido-leyenda');

        enlace.addEventListener('click', function (e) {
          e.preventDefault(); // Evitar navegación por defecto
          const icono = this.querySelector('.icono');
          icono.classList.toggle('activo'); // Alternar rotación del ícono

          // Mostrar/ocultar la imagen
          if (contenidoLeyenda.style.display === 'none') {
            contenidoLeyenda.style.display = 'block';
          } else if (contenidoLeyenda.style.display === 'block') {
            contenidoLeyenda.style.display = 'none';
          }
        });

        leyendaLista.appendChild(li);
      }
    });
  } else {
    //legend.style.display = 'none'; // Ocultar el botón
    //cuadroLeyenda.style.opacity = '0';
    leyendaLista.innerHTML = '<li>No hay capas activas.</li>'; // Mensaje por defecto
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const toggleLegendButton = document.getElementById('toggleLegend');
  const hideLegendButton = document.getElementById('hideLegend');
  const cuadroLeyenda = document.getElementById('cuadroLeyenda');
  const legend = document.getElementById('legend');

  // Mostrar el cuadroLeyenda y ocultar el botón con animación
  toggleLegendButton.addEventListener('click', () => {
    toggleLegendButton.style.display = 'none'; // Ocultar botón con animación
    hideLegendButton.style.display = 'block'; // Ocultar botón con animación
    setTimeout(() => {
      hideLegendButton.style.pointerEvents = 'auto'; // Deshabilitar interacciones del botón
      cuadroLeyenda.classList.add('mostrar'); // Mostrar el recuadro con animación
    }, 300); // Coincide con el tiempo de la transición
  });

  // Regresar al estado inicial con animación inversa
  document.getElementById('hideLegend').addEventListener('click', () => {
    cuadroLeyenda.classList.remove('mostrar'); // Ocultar el recuadro con animación
    setTimeout(() => {
      legend.style.pointerEvents = 'auto'; // Habilitar interacciones del botón
      toggleLegendButton.style.display = 'block'; // Mostrar el botón con animación
      hideLegendButton.style.display = 'none'; // Ocultar el botón con animación
    }, 300); // Coincide con el tiempo de la transición
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const enlaces = document.querySelectorAll('.leyenda-enlace');

  enlaces.forEach(enlace => {
    enlace.addEventListener('click', (e) => {
      e.preventDefault(); // Evita que el enlace realice la navegación

      const icono = enlace.querySelector('.icono');

      // Alternar entre ">" y "v" al hacer clic
      if (icono.classList.contains('activo')) {
        //icono.textContent = '>'; // Flecha hacia la derecha
        icono.classList.remove('activo');
      } else {
        //icono.textContent = 'v'; // Flecha hacia abajo
        icono.classList.add('activo');
      }
    });
  });
});

//Redimensionar leyenda
document.addEventListener("DOMContentLoaded", () => {
  const cuadroLeyenda = document.querySelector(".cuadroLeyenda");

  let isResizing = false;
  let startX, startY, startWidth, startHeight;

  cuadroLeyenda.addEventListener("mousedown", (e) => {
    const isResizeHandle = e.target === cuadroLeyenda && e.offsetX > cuadroLeyenda.offsetWidth - 24 && e.offsetY < 24; // Verifica si el clic es en el controlador de redimensionar
    if (isResizeHandle) {
      isResizing = true;
      startX = e.clientX;
      startY = e.clientY;
      startWidth = cuadroLeyenda.offsetWidth;
      startHeight = cuadroLeyenda.offsetHeight;
      e.preventDefault(); // Evita la selección de texto
    }
  });

  document.addEventListener("mousemove", (e) => {
    if (isResizing) {
      const newWidth = startWidth + (e.clientX - startX);
      const newHeight = startHeight - (e.clientY - startY); // Redimensionar hacia arriba
      const maxHeight = window.innerHeight * 0.87; // Limitar la altura máxima al 87% del alto de la pantalla
      const maxWidth = 380; // Limitar el ancho máximo a 380px
      cuadroLeyenda.style.width = Math.min(Math.max(100, newWidth), maxWidth) + "px"; // Limita el ancho entre mínimo y 730px
      cuadroLeyenda.style.height = Math.min(Math.max(50, newHeight), maxHeight) + "px"; // Limita la altura entre mínimo y 80% del alto de la pantalla
    }
  });

  document.addEventListener("mouseup", () => {
    if (isResizing) {
      isResizing = false;
    }
  });
});



//
// CONTROLES DE MANIPULACIÓN DE CAPAS
//
// const checkboxes = document.querySelectorAll('.form-check-input');

// checkboxes.forEach(checkbox => {
//   checkbox.addEventListener('click', function() {
//     const capaTematica = global.mapa.getLayers().getArray().find(layer => layer.get('id') === this.id) || null;
//     if(capaTematica != null) {
//       if (this.checked) {
//         capaTematica.setVisible(true);
//         activarBoton(this.id, true);
//       } else {
//         capaTematica.setVisible(false);
//         activarBoton(this.id, false);
//       }
//     }
//   });
// });

/* const checkboxes = document.querySelectorAll('.form-check-input');

checkboxes.forEach(checkbox => {
  checkbox.addEventListener('click', function() {
    const capaTematica = global.mapa.getLayers().getArray().find(layer => layer.get('id') === this.id) || null;
    if (capaTematica != null) {
      if (this.checked) {
        capaTematica.setVisible(true);
        activarBoton(this.id, true);
        // Si se activa 'tiempoDesplazamientoCapitalCercano', activar otras capas
        if (this.id === 'tiempoDesplazamientoCapitalCercano') {
          activarCapasAdicionales(true);
        }
      } else {
        capaTematica.setVisible(false);
        activarBoton(this.id, false);
        // Si se desactiva 'tiempoDesplazamientoCapitalCercano', desactivar otras capas
        if (this.id === 'tiempoDesplazamientoCapitalCercano') {
          activarCapasAdicionales(false);
        }
      }
    }
  });
});

function activarCapasAdicionales(activar) {
  const capasAdicionales = ['viasNacional', 'viasDepartamental', 'viasVecinal', 'capitales'];
  capasAdicionales.forEach(id => {
    const capa = global.mapa.getLayers().getArray().find(layer => layer.get('id') === id);
    if (capa) {
      capa.setVisible(activar);
    }
    // Actualizar el estado del checkbox correspondiente
    const checkbox = document.getElementById(id);
    if (checkbox) {
      checkbox.checked = activar;
    }
    // Activar o desactivar el botón correspondiente
    activarBoton(id, activar);
  });
} */

const dependenciasCapas = {
  'tiempoDesplazamientoCapitalCercano': ['viasNacional', 'viasDepartamental', 'viasVecinal', 'capitales'],
  'densidadViviendas': ['viasNacional', 'viasDepartamental', 'viasVecinal'],
  'densidadServiciosFinancieros': ['viasNacional', 'viasDepartamental', 'viasVecinal'],
  'densidadComercio': ['viasNacional', 'viasDepartamental', 'viasVecinal'],
  'densidadMercado': ['viasNacional', 'viasDepartamental', 'viasVecinal'],
  'densidadInmobiliario': ['viasNacional', 'viasDepartamental', 'viasVecinal'],
  'vabTotal': ['densidadViviendas'],
  'vabLima': ['densidadViviendas'],
  'vabCallao': ['densidadViviendas']
};

const capasNoIdentificables = new Set([
  'densidadViviendas'
]);

const checkboxes = document.querySelectorAll('.form-check-input');

checkboxes.forEach(checkbox => {
  /*
  ////Versión funcional anterior
  checkbox.addEventListener('click', function () {
    const capaPrincipal = global.mapa.getLayers().getArray().find(layer => layer.get('id') === this.id) || null;
    if (capaPrincipal) {
      const activar = this.checked;
      capaPrincipal.setVisible(activar);
      //actualizarPanelDebug();
      activarBoton(this.id, activar);
      //activarIdentificar(this.id);    ////////OMD Cambio propuesto por trabajar

      // Activar/desactivar capas dependientes, si las hay
      if (dependenciasCapas.hasOwnProperty(this.id)) {
        manejarDependencias(this.id, activar);
      }
    }
  });
  */
  checkbox.addEventListener('click', function () {
    const layerId = this.id;
    const capaPrincipal = global.mapa.getLayers()
      .getArray()
      .find(layer => layer.get('id') === layerId) || null;

    if (!capaPrincipal) return;

    const activar = this.checked;
    capaPrincipal.setVisible(activar);
    activarBoton(layerId, activar);

    if (activar && !capasNoIdentificables.has(layerId)) {
      activarIdentificar(layerId);
    } else {
      desactivarIdentificarSiCorresponde(layerId);
    }
    if (dependenciasCapas.hasOwnProperty(layerId)) {
      manejarDependencias(layerId, activar);
    }
  });
  
});

////Nueva función
function desactivarIdentificarSiCorresponde(layerId) {
  if (activoInformacion === layerId) {
    activoInformacion = null;

    if (typeof cubrir !== 'undefined') {
      cubrir.setPosition(undefined);
    }

    if (typeof contenido !== 'undefined') {
      contenido.innerHTML = '';
    }
  }
}

function manejarDependencias(idPrincipal, activar) {
  const capasDependientes = dependenciasCapas[idPrincipal];
  capasDependientes.forEach(id => {
    const capa = global.mapa.getLayers().getArray().find(layer => layer.get('id') === id);
    if (capa) {
      capa.setVisible(activar);
      //actualizarPanelDebug();
    }

    const checkbox = document.getElementById(id);
    if (checkbox) {
      checkbox.checked = activar;
    }

    activarBoton(id, activar);
  });
}

const dropdownItems = document.querySelectorAll('.dropdown-item');
dropdownItems.forEach(item => {
  item.addEventListener('click', function(event){
    event.preventDefault();
    const i = item.getAttribute('id');
    //const link = document.createElement('a');
    const capa = capasTematicas.find(e => e.id === i.substring(1));
    if (capa !== undefined) {
      if (i.substring(0,1) === 'i') {
        activoInformacion = capa.id;
      }
      if (i.substring(0,1) === 'd') {
        const url = urlWFS + 'service=WFS&request=GetFeature&outputFormat=SHAPE-ZIP&srsName=epsg:4326&typeName=' + capa.nombre;
        /*link.href = url;
        link.download = capa.nombre + '_' + fechaHoy() + '.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);*/
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = capa.nombre + '_' + fechaHoy() + '.zip';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
          });
      }
    }
  });
});

// Esperamos a que cargue el DOM
document.addEventListener("DOMContentLoaded", function() {
  const transparencySliders = document.querySelectorAll('.transparency-slider'); // Seleccionamos todos los sliders de transparencia
  transparencySliders.forEach(slider => {
    slider.addEventListener('input', function() {
      const i = slider.getAttribute('id');
      const capa = capasTematicas.find(e => e.id === i.substring(1)); // Quitamos "t" del ID
      if (capa) {
        const layer = global.mapa.getLayers().getArray().find(l => l.get('id') === capa.id) || null;
        if (layer) {
          layer.setOpacity(parseFloat(slider.value)); // Aplicamos la opacidad en tiempo real
        }
      }
    });
  });
});

/* function actualizarPanelDebug() {
  const capas = global.mapa.getLayers().getArray();
  const estadoDiv = document.getElementById('estado-capas');
  estadoDiv.innerHTML = ''; // Limpiar antes de actualizar

  capas.forEach(capa => {
    const id = capa.get('id');
    if (!id) return;
    const visible = capa.getVisible();
    const item = document.createElement('div');
    item.textContent = `${visible ? '✅' : '❌'} ${id}`;
    estadoDiv.appendChild(item);
  });
} */

function debounce(fn, delay = 300) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}

function limpiarTextoCQL(texto) {
  // Permitimos letras, números, espacios y algunos acentos.
  return texto
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // quitar acentos si deseas
    .replace(/[^a-zA-Z0-9\sáéíóúñÁÉÍÓÚÑ]/g, "")      // permitir solo caracteres válidos
    .trim()
    .toLowerCase();
}

function activarFiltroCQL({ inputId, layerId, campo, delay = 300 }) {
  const input = document.getElementById(inputId);
  if (!input) return;

  const aplicarFiltro = debounce((valor) => {
    const layer = global.mapa.getLayers().getArray()
      .find(l => l.get("id") === layerId);

    if (!layer) return;

    const source = layer.getSource();

    // Resetear filtro
    if (!valor) {
      source.updateParams({ CQL_FILTER: null });
      return;
    }

    // Filtro simple, sin funciones, WAF-safe
    source.updateParams({
      CQL_FILTER: `${campo} ILIKE '${valor}%'`
    });
    activarIdentificar(layerId);
  }, delay);

  input.addEventListener("input", function () {
    const valor = limpiarTextoCQL(this.value);
    aplicarFiltro(valor);
  });
}

function activarIdentificar(layerId) {
  activoInformacion = layerId;
  // Opcional: feedback visual
  document.querySelectorAll('.dropdown-item.identificar-activo')
    .forEach(el => el.classList.remove('identificar-activo'));

  const btn = document.querySelector(`#i${layerId}`);
  if (btn) btn.classList.add('identificar-activo');
}

activarFiltroCQL({
  inputId: "filtroCcppAsentamientosDispersos",
  layerId: "ccppAsentamientosDispersos",
  campo: "cen_pob",
  delay: 300
});

activarFiltroCQL({
  inputId: "filtroServiciosEducativo",
  layerId: "serviciosEducativos",
  campo: "CEN_EDU",
  delay: 300
});
